<template>
    <section class="view" v-if="hasPermissions(['Assignment-Break Read', 'Assignment-Break Write', 'Assignment-Break Break-Upload'])">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                In this view, you can create customized breaks that can be assigned to your daily assignments.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="breaks.length && hasPermissions(['Assignment-Break Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <UploadOptions
                    v-if="hasPermissions(['Assignment-Break Break-Upload'])"
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'break_template_file'"
                    @data="upload($event)"
                />
                <button v-if="hasPermissions(['Assignment-Break Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['Assignment-Break Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="breaks.length  && hasPermissions(['Assignment-Break Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="breaks"
                                :search="search"
                                :checkable="true"
                                :link="'#'"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion_child(rest_api_child, $event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Break'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api_child"
            :notyf="notyf"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Break Update'"
            :rest_api="rest_api_child"
            :notyf="notyf"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            :breadcrumb="breadcrumb"
            @spliceObject="splice_object($event)"
        />

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="'breaks_falied_template_file'"
        />

        <HelperModal :helps="helps"/>

        <WaitingModal/>

    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DinamicTable         from    '@/components/DinamicTable'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import UploadOptions        from    '@/components/UploadOptions'
import UploadSummary        from    '@/components/UploadSummary'
import HelperModal          from    '@/components/HelperModal'
import { Notyf }            from    'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name:   'Break',

    components:{
        Breadcrumb,
        WaitingModal,
        FormModal,
        UpdateModal,
        DeletionModal,
        DinamicTable,
        DeletionMassiveModal,
        UploadOptions,
        UploadSummary,
        UnauthorizedComponent,
        HelperModal
    },

    data(){
        return{
            notyf,
            title_page:             'Breaks',
            rest_api:               `breaks`,
            rest_api_child:         `breaks`,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            excel_file_headers:     Resources.excel_file_headers,
            empty_format_data:      Resources.empty_format_data,
            excel_fields_required:  Resources.excel_fields_required,
            add_btn:                'Add Break',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           null,
            single_object:          {},
            breaks:                 [],
            array_options:          {},
            select_ids:             [],
            excel_data:             [],
            summary:                [],
            helps:              Resources.helps
        }
    },

    methods:{

        format_boolean(value)
        {
            let boolean_string = ''
            value ? boolean_string = 'Yes' : boolean_string = 'No'
            return boolean_string
        },
        
        unshift_object(new_object)
        {
            this.breaks.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.breaks.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index = index
            this.single_object = this.breaks[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index = index
            this.single_object = {...this.breaks[index]}
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.breaks = data.breaks
            this.array_options = {
                shift_id: data.shifts
            }
        },

        trashing(index)
        {
            this.breaks.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.breaks.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids: this.select_ids,
            }

            let sendingMassive = await this.massive_delete(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.breaks.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.breaks.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        async upload(data)
        {
            this.excel_data = [];
            const messages_error = []
            let error = false

            for ( const [index, value] of data.entries() ) {
                const entity = {}
                console.log(index)

                for (const prop in this.excel_file_headers) {
                    entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                }
                this.excel_data.push(entity)
            }

            if(!error)
            {
                this.loader(true)
                const temp_rest_api = this.rest_api
                this.rest_api = this.rest_api_child
                const response = await this.post(`${this.rest_api}/massive`, { breaks: this.excel_data })
                this.rest_api = temp_rest_api
                this.loader()
                if(response.status)
                {
                    notyf.success('Success!')
                    this.summary = response.data.summary
                    window.$('#upload-summary').modal('show')
                    for (const _break of response.data.breaks) {
                        this.unshift_object(_break);
                    }
                }
                else
                {
                    this.error_handling(response)
                }
            }
            else
            {
                this.notyf.error({ ripple: false, message: messages_error.join('\n') })
            }
            
            this.$refs.file_excel.clear_data()
        },

    },

    computed:
    {
        selected()
        {
            const bool = this.breaks.filter(item => item.checked)
            return Boolean(bool.length)
        }
    },

    async mounted(){
        if(this.hasPermissions(['Assignment-Break Read', 'Assignment-Break Write']))
        {
            await this.api_request()
        }
    }
}
</script>